import React, { useState, useEffect, Children } from 'react';
import { Button, Card, Form, Row, Col } from 'react-bootstrap';
import CloseButton from 'react-bootstrap/CloseButton';

export default function EnumField({ value, onChange, mode, options = [], config, field, ...props }) {
    const [enumValues, setEnumValues] = useState([]);

    // Load enum values from config when component mounts or config changes
    useEffect(() => {
        if (config?.enumValues) {
            setEnumValues(config.enumValues);
        }
    }, [config?.enumValues]);

    if (mode === "view") return <span>{value}</span>;

    // Handle edit mode for enum values
    if (mode === "edit" && field?.editEnumValues) {
        const handleEnumValueChange = (index, newValue) => {
            const newEnumValues = [...enumValues];
            newEnumValues[index] = newValue;
            setEnumValues(newEnumValues);
            
            // Update the config with new enum values
            const updatedConfig = {
                ...config,
                enumValues: newEnumValues
            };
            onChange(updatedConfig);
        };

        const handleAddEnumValue = () => {
            const newEnumValues = [...enumValues, ""];
            setEnumValues(newEnumValues);
            
            const updatedConfig = {
                ...config,
                enumValues: newEnumValues
            };
            onChange(updatedConfig);
        };

        const handleRemoveEnumValue = (index) => {
            const newEnumValues = enumValues.filter((_, stateIndex) => stateIndex !== index);
            setEnumValues(newEnumValues);
            
            const updatedConfig = {
                ...config,
                enumValues: newEnumValues
            };
            onChange(updatedConfig);
        };

        return (
            <Card className="mt-3">
                <Card.Body>
                    <Row>
                        <Col md={12}>
                            <div className="mb-3">
                                <label>Enum Values *</label>
                                {Children.toArray(
                                    Array.isArray(enumValues) && enumValues.map((value, index) => (
                                        <div key={index} className="d-flex align-items-end form-group row mb-3">
                                            <div className="col-lg-10">
                                                <label>Option {index + 1}</label>
                                                <input
                                                    type="text"
                                                    className="form-control input-default"
                                                    placeholder={`Option ${index + 1}`}
                                                    onChange={(e) => handleEnumValueChange(index, e.target.value)}
                                                    value={value}
                                                />
                                            </div>
                                            <div className="col-lg-2">
                                                <CloseButton
                                                    onClick={() => handleRemoveEnumValue(index)}
                                                />
                                            </div>
                                        </div>
                                    ))
                                )}
                                <div className="my-3">
                                    <Button
                                        variant="primary"
                                        onClick={handleAddEnumValue}
                                    >
                                        Add options
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        );
    }
    
    return (
        <select 
            value={value || ""} 
            onChange={e => onChange(e.target.value)} 
            className="form-select"
            {...props}
        >
            <option value="">Select an option</option>
            {options.map((option, index) => (
                <option key={index} value={option.value || option}>
                    {option.label || option}
                </option>
            ))}
        </select>
    );
} 